const CONFIG_PRODUCTION = {
  VERSION: "0.0.1",
  BASE_URL: "https://api.bo.kuwego.console.teamapt.com/api/v1",
};

export default CONFIG_PRODUCTION;
